module.exports = __webpack_public_path__ + "img/sup_deposit_crypto2.0e8be64e.jpg";